<template>
  <v-layout row align-start justify-space-between class="pa-2">

    <v-flex grow>
      <v-textarea
        placeholder="Questions / Comments"
        hide-details
        rows=15
        v-model="messageBody"
      ></v-textarea>
    </v-flex>

    <v-flex shrink class="ml-2">
      <v-layout column>
        <v-flex shrink>
          <span class="subheading all-caps">Send To:</span>
          <v-checkbox v-if="employee && shift.userId"
            label="Employee"
            v-model="sendEmployee"
          />
          <v-checkbox v-if="client"
            label="Client"
            v-model="sendClient"
          />
        </v-flex>

        <v-flex>
          <v-btn @click="sendMessage" color="success" :disabled="(!messageBody || !validRecipients) || sending" :loading="sending" class="no-margin-button">
            <v-icon left>
              forum
            </v-icon>
            Send
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>

  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
    validRecipients: function() {
      return this.sendClient || this.sendEmployee
    },
  },
  props: {
    employee: Boolean,
    client: Boolean,
    shift: Object,
  },
  created () {

  },
  data () {
    return {
      messageBody: null,
      sendClient: false,
      sendEmployee: false,
      recipientIds: [],
      clientIds: [],
      sending: false,
    }
  },
  methods: {
    discardMessage () {
      this.messageBody = null
      this.recipientIds = []
      this.sendEmployee = false
      this.sendClient = false
    },
    sendMessage () {
      this.sending = true
      if (this.shift.userId && this.sendEmployee) {
        this.recipientIds.push(this.shift.userId)
      }
      if (this.sendClient) {
        this.recipientIds.push(this.shift.clientIds)
      }

      this.$store.dispatch('messages/shiftInquiry',
        {
          shiftId: this.shift.id,
          senderId: this.user.id,
          recipientIds: this.recipientIds,
          message: this.messageBody,
        }
      ).then(res => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: 'Message sent!' })
      })
      .catch(res => {
        this.$store.dispatch('global/showSnackbarError', { message: 'Something went wrong with that message' })
      })
      .finally(res => {
        this.sending = false
        this.discardMessage()
      })
    },
  },
}
</script>
